import { useTranslation } from 'react-i18next';
import { type ChartData } from './chartConfigUtils';
import StandardChart from './StandardChart';

interface CurrencyValueChartConfig {
    readonly chartType: 'column' | 'line' | 'spline';
    readonly yAxisTitleKeyEur: string;
    readonly yAxisTitleKeyLei: string;
    readonly yAxisTitleFallbackEur: string;
    readonly yAxisTitleFallbackLei: string;
    readonly color: string;
    readonly seriesNameKey: string;
    readonly seriesNameFallback: string;
}

interface CurrencyValueChartProps {
    readonly data: readonly ChartData[];
    readonly loading?: boolean;
    readonly referenceValue?: number;
    readonly currency?: 'EUR' | 'LEI';
    readonly config: CurrencyValueChartConfig;
}

function CurrencyValueChart({
    data,
    loading = false,
    referenceValue,
    currency,
    config,
}: CurrencyValueChartProps): JSX.Element {
    const { t } = useTranslation();
    const isEur = currency === 'EUR';
    return (
        <StandardChart
            data={data}
            loading={loading}
            referenceValue={referenceValue}
            config={{
                chartType: config.chartType,
                yAxisTitleKey: isEur ? config.yAxisTitleKeyEur : config.yAxisTitleKeyLei,
                yAxisTitleFallback: isEur
                    ? config.yAxisTitleFallbackEur
                    : config.yAxisTitleFallbackLei,
                yAxisColor: config.color,
                seriesNameKey: config.seriesNameKey,
                seriesNameFallback: config.seriesNameFallback,
                seriesColor: config.color,
                valueSuffix: isEur
                    ? (t('statistics.currencyEur', ' EUR') ?? ' EUR')
                    : (t('statistics.currencyLei', ' Lei') ?? ' Lei'),
            }}
        />
    );
}

export default CurrencyValueChart;
